export default {"src":"/_next/static/media/telegram-logo.c1e70732.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};